import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, Button, Stack, FormControl, InputLabel, Select,
  MenuItem, TextField
} from '@mui/material';
import { Api, Send } from '@mui/icons-material';

const ServiceTestModal = ({ open, onClose, service, onSendRequest }) => {
  const [method, setMethod] = useState('GET');
  const [path, setPath] = useState('/api/health');
  const [body, setBody] = useState('');

  const handleSubmit = () => {
    onSendRequest(service.key, path, method, body);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Api />
          Тестирование {service?.name}
        </Box>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 1 }}>
          <FormControl fullWidth>
            <InputLabel>Метод</InputLabel>
            <Select
              value={method}
              onChange={(e) => setMethod(e.target.value)}
              label="Метод"
            >
              {['GET', 'POST', 'PUT', 'DELETE', 'PATCH'].map(m => (
                <MenuItem key={m} value={m}>{m}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            label="Путь запроса"
            value={path}
            onChange={(e) => setPath(e.target.value)}
            placeholder="/api/health или /api/endpoint"
            fullWidth
          />

          {method !== 'GET' && (
            <TextField
              label="Тело запроса (JSON)"
              multiline
              rows={4}
              value={body}
              onChange={(e) => setBody(e.target.value)}
              placeholder='{"key": "value"}'
              fullWidth
            />
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Отмена</Button>
        <Button 
          variant="contained" 
          onClick={handleSubmit}
          startIcon={<Send />}
        >
          Отправить запрос
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ServiceTestModal;